export const PopupsActionsTypes = {
  GET: {
    POPUPS_PENDING: "GET_POPUPS_PENDING",
    POPUPS_SUCCESS: "GET_POPUPS_SUCCESS",
    POPUPS_ERROR: "GET_POPUPS_ERROR",
  },
};
